import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs: any;
import * as $ from 'jquery';
import { SessionService } from '../../../shared/services/session.service';


@Component({
  selector: 'app-fk-character-n',
  templateUrl: './fk-character-n.component.html',
  styleUrls: ['./fk-character-n.component.scss']
})


export class FKCharacterNComponent implements OnInit {
    public bloburl: string;
private stage: any;
  
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<FKCharacterNComponent>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;
   
  }


  private loadScript(scriptUrl: string, className: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.className = className;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }



  

  ngOnInit() {
var stage = new createjs.Stage("fk_swedishcanvas");
    this.stage = stage;
    var strbloburl = this.sessionService.bloburl;

    var fk_swedishcanvas: any = document.getElementById('fk_swedishcanvas');
    fk_swedishcanvas.width = 1785;
    fk_swedishcanvas.height = 885;
    var queue = new createjs.LoadQueue();
    queue.loadManifest([
      { id: "MajemaSkol", src: "/Lasresan/FK/FK-Startpage/Fonts/MajemaSkol.ttf", type: "font" }
    ]);
    setTimeout(function () {
      
    commonfunc();
      }, 1000);

    function commonfunc() {

      createjs.MotionGuidePlugin.install();
      N();
      n();
      function N() {

        var bitmap = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Swedishcharacter/Images/frame.png");
        bitmap.setTransform(0, 0, 0.992, 0.97);

        var pencil = new Image();
        pencil.src = strbloburl + "/Lasresan/FK/FK-RB/Exercise/Swedishcharacter/Images/pencil.png";
        var bitmaps = new createjs.Bitmap(pencil);
        bitmaps.setTransform(255, -11, 0.8, 0.8);

        var shape1 = new createjs.Shape();
        shape1.graphics.beginFill("#000000").drawCircle(330, 55 - 5, 6);
        shape1.setTransform(-75, 84);

        var shape = new createjs.Shape();
        shape.graphics.beginFill("#FFCF21").drawCircle(255, 139 - 5, 15);
        var circleShadow = new createjs.Shadow("#ff0000", 0, 0, 5);
        shape.shadow = circleShadow;
        circleShadow.blur = 0;
        createjs.Tween.get(circleShadow).to({
          blur: 50
        }, 500).wait(100).to({
          blur: 0
        }, 500).to({
          blur: 50
        }, 500).wait(10).to({
          blur: 5
        }, 500);
        var data = {

          frames: {
            width: 40,
            height: 40
          },
          animations: {
            trash: 0,
            male: 1,
            wait: 2,
            library: 3,
            female: 4,
            hanger: 5,
            stairs: 6,
            noparking: 7
          }
        }

        var r1 = new createjs.Shape();
        r1.graphics.f('').s('lightgrey').ss(2).drawRect(0, 0, 380, 200)
        r1.setTransform(195, 130);

        var r2 = new createjs.Shape();
        r2.graphics.f('#D6EDF1').s('lightgrey').ss(2).drawRect(0, 0, 380, 191)
        r2.setTransform(195, 330);

        var r3 = new createjs.Shape();
        r3.graphics.f('#FFFFFF').s('lightgrey').ss(2).drawRect(0, 0, 380, 192)
        r3.setTransform(195, 521);

        var rectangle1 = new createjs.Shape();
        rectangle1.graphics.f('').s('#B7E1E6').ss(2).drawRoundRect(0, 0, 410, 615, 10)
        rectangle1.setTransform(180.5, 115);

        var text = new createjs.Text("N", "750px MajemaSkol", "#000000");        
        text.textBaseline = "alphabetic";
        text.x = 203;
        text.y = 520;



        //Images 
        var Imagecontainer = new createjs.Container();
        var bitmap1 = new createjs.Bitmap(strbloburl + "/Lasresan/FK/FK-RB/Exercise/Swedishcharacter/Images/nos.png");
        bitmap1.setTransform(916, 334);


        var text1 = new createjs.Text("nos", "78px MajemaSkol_Exercise_bold", "#000000");
        text1.setTransform(1066, 355);

        
        Imagecontainer.addChild(bitmap1, text1);
        Imagecontainer.setTransform(410, 38);

        //end

        var box_Container = new createjs.Container();
        var playrect = new createjs.Shape();
        playrect.graphics.f('#2398D1').s('#2398D1').ss(1.5).drawRect(0, 0, 40, 40);
        playrect.setTransform(597, 480);

        var triangleplay = new createjs.Shape();
        triangleplay.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(1.5).moveTo(0, 0).lineTo(0, 16).lineTo(10, 8).lineTo(0, 0);
        triangleplay.setTransform(614, 492);

        var trianglepause = new createjs.Shape();
        trianglepause.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(5).moveTo(0, 0).lineTo(0, 16).moveTo(10, 0).lineTo(10, 16);
        trianglepause.setTransform(613, 492);
        trianglepause.visible = false;

        box_Container.addChild(playrect, triangleplay, trianglepause);
        box_Container.setTransform(-210, 274);
        box_Container.alpha = 1;
        box_Container.visible = true;

        var box_Container_disable = new createjs.Container();

        var playrect_disable = new createjs.Shape();
        playrect_disable.graphics.f('#2398D1').s('#2398D1').ss(1.5).drawRect(0, 0, 40, 40);
        playrect_disable.setTransform(597, 480);

        var triangleplay_disable = new createjs.Shape();
        triangleplay_disable.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(1.5).moveTo(0, 0).lineTo(0, 16).lineTo(10, 8).lineTo(0, 0);
        triangleplay_disable.setTransform(614, 492);

        box_Container_disable.addChild(playrect_disable, triangleplay_disable);
        box_Container_disable.setTransform(-210, 274);
        box_Container_disable.alpha = 0.4;
        box_Container_disable.visible = false;

        //play from starting (restart)   

        var box_Container1 = new createjs.Container();

        var previous = new createjs.Shape();
        previous.graphics.f('#2398D1').s('#2398D1').ss(1.5).drawRect(0, 0, 40, 40);
        previous.setTransform(550, 480);

        var triangleprev = new createjs.Shape();
        triangleprev.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(1.5).moveTo(0, 0).lineTo(0, 16).lineTo(10, 8).lineTo(0, 0);
        triangleprev.setTransform(577, 509);
        triangleprev.rotation = 180;

        var triangleprevpause = new createjs.Shape();
        triangleprevpause.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(5).moveTo(0, 0).lineTo(0, 16);
        triangleprevpause.setTransform(565, 493);

        box_Container1.addChild(previous, triangleprev, triangleprevpause);
        box_Container1.setTransform(-210, 274);
        box_Container1.alpha = 0.4;


        var line_black = new createjs.Shape();
        line_black.graphics.beginStroke("#000000").setStrokeStyle(17.5).moveTo(15, 140);
        line_black.setTransform(242, 184);
        var cmd_black = line_black.graphics.lineTo(15, 140).command;

        var line_black1 = new createjs.Shape();
        line_black1.graphics.beginStroke("#000000").setStrokeStyle(23).moveTo(16, 145);
        line_black1.setTransform(371.5, 180);
        line_black1.skewY = 9;
        var cmd_black1 = line_black1.graphics.lineTo(16, 145).command;

        var line_black2 = new createjs.Shape();
        line_black2.graphics.beginStroke("#000000").setStrokeStyle(17.5).moveTo(15, 145);
        line_black2.setTransform(496, 182);
        var cmd_black2 = line_black2.graphics.lineTo(15, 145).command;

        //changes

        var line = new createjs.Shape();
        line.graphics.beginStroke("#FFFFFF").setStrokeStyle(23).moveTo(10, 200);
        line.setTransform(245, 129);
        var cmd = line.graphics.lineTo(10, 0).command;

        var line1 = new createjs.Shape();
        line1.graphics.beginStroke("#D6EDF1").setStrokeStyle(23).moveTo(10, 193);
        line1.setTransform(245, 330);
        var cmd1 = line1.graphics.lineTo(10, 0).command;

        var line2 = new createjs.Shape();
        line2.graphics.beginStroke("#FFFFFF").setStrokeStyle(21.5).moveTo(128, 155);
        line2.setTransform(254, 168);
        var cmd2 = line2.graphics.lineTo(20, 0).command;

        var line3 = new createjs.Shape();
        line3.graphics.beginStroke("#D6EDF1").setStrokeStyle(23).moveTo(145, 185);
        line3.setTransform(374, 335);
        var cmd3 = line3.graphics.lineTo(20, 0).command;        

        var line4 = new createjs.Shape();
        line4.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(2.5).moveTo(0, 0).lineTo(0, 32).lineTo(14, 23).lineTo(0, 0);
        line4.setTransform(267, 141);

        var line5 = new createjs.Shape();
        line5.graphics.f("#D6EDF1").beginStroke("#D6EDF1").setStrokeStyle(2.5).moveTo(0, 0).lineTo(20, 0)
          .lineTo(18, 25).lineTo(0, 0);
        line5.setTransform(502.6, 476);

        var line6 = new createjs.Shape();
        line6.graphics.beginStroke("#FFFFFF").setStrokeStyle(23).moveTo(10, 0);
        line6.setTransform(503, 129);
        var cmd6 = line6.graphics.lineTo(10, 200).command;

        var line7 = new createjs.Shape();
        line7.graphics.beginStroke("#D6EDF1").setStrokeStyle(23).moveTo(10, 0);
        line7.setTransform(503, 331);
        var cmd7 = line7.graphics.lineTo(10, 144.3).command;

        var triangle1 = new createjs.Shape();
        triangle1.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(2).moveTo(1, 0).lineTo(-11.8, 10)
          .lineTo(11, 10).lineTo(1, 0);
        triangle1.setTransform(388.1, 318);

        var triangle2 = new createjs.Shape();
        triangle2.graphics.f("#D6EDF1").beginStroke("#D6EDF1").setStrokeStyle(2).moveTo(1, 0).lineTo(-11.8, 10)
          .lineTo(11, 10).lineTo(1, 0);
        triangle2.setTransform(386.8, 341);
        triangle2.rotation = 180;

        var topline = new createjs.Shape();
        topline.graphics.f("lightgrey").beginStroke("lightgrey").setStrokeStyle(2).moveTo(0, 0).lineTo(380, 0);
        topline.setTransform(195, 330);

        //changes end

        var tween1 = createjs.Tween.get(cmd, { paused: true }).wait(1000).to({ x: 10, y: 200 }, 500);
        var tween2 = createjs.Tween.get(cmd1, { paused: true }).wait(1500).to({ x: 10, y: 193 }, 500);
        var tween3 = createjs.Tween.get(cmd2, { paused: true }).wait(2500).to({ x: 128, y: 155 }, 500)
        var tween4 = createjs.Tween.get(cmd3, { paused: true }).wait(3000).to({ x: 145, y: 185 }, 500)
        var tween5 = createjs.Tween.get(line4, { paused: true }).wait(2500).to({ alpha: 0 }, 0)
        var tween6 = createjs.Tween.get(line5, { paused: true }).wait(3460).to({ alpha: 0 }, 0);
        var tween8 = createjs.Tween.get(cmd7, { paused: true }).wait(3500).to({ x: 10, y: 0 }, 500); // line moving backwards
        var tween7 = createjs.Tween.get(cmd6, { paused: true }).wait(4000).to({ x: 10, y: 0 }, 500);

        var tween12 = createjs.Tween.get(cmd_black, { paused: true }).wait(1490).to({ x: 15, y: 150 }, 0);
        var tween13 = createjs.Tween.get(cmd_black1, { paused: true }).wait(3000).to({ x: 16, y: 150 }, 0);
        var tween14 = createjs.Tween.get(cmd_black2, { paused: true }).wait(4000).to({ x: 15, y: 150 }, 0);
        var tween15 = createjs.Tween.get(triangle1, { paused: true }).wait(3000).to({ alpha: 0 }, 0);
        var tween16 = createjs.Tween.get(triangle2, { paused: true }).wait(3000).to({ alpha: 0 }, 0);

        //pencil
        var tween9 = createjs.Tween.get(bitmaps, { paused: true }).wait(1000).to({ x: 255, y: 375 }, 1000)
          .wait(500).to({ x: 265, y: 5 }, 0).to({ x: 381, y: 184 }, 500)
          .to({ x: 386, y: 184 }, 0).to({ x: 510, y: 375 }, 500)
          .to({ x: 510, y: 350 }, 0).to({ x: 510, y: 190 }, 500)
          .to({ x: 510, y: 190 }, 0).to({ x: 510, y: -10 }, 500)
          .wait(1000).to({ alpha: 0 }, 0);

        //animation circle
        var tween10 = createjs.Tween.get(shape, { paused: true }).wait(500).to({ alpha: 0 }, 0);
        var tween11 = createjs.Tween.get(shape1, { paused: true }).wait(500).to({ alpha: 0 }, 0);

        var tween29 = createjs.Tween.get(box_Container, { paused: true }).wait(5500).call(function () {
          playdisable();
          myAudio.play();
        });

        function playdisable() {
          box_Container.visible = false;
          box_Container_disable.visible = true;
        }

        stage.addChild(box_Container_disable, box_Container, box_Container1, Imagecontainer);

        stage.addChild(r2, text, line, line1, line2, line3, line4, line5, line6, line7, triangle1, triangle2, topline, r1, shape, rectangle1, r3, shape1, line_black, line_black1, line_black2, bitmaps);

        var myAudio: any = document.getElementById("myAudio");
        myAudio.oncanplaythrough = setTimeout(function () {
          setTime()
        }, 900);
        function setTime() {
          // myAudio1.currentTime = ;
        } 

        function linestop(tween) {
          if (tween._paused) {
            tween.paused = false;
            tween.setPaused(false);
          
            trianglepause.visible = true;
            triangleplay.visible = false;
          } else {
            tween.paused = true;
            tween.setPaused(true);
           
            triangleplay.visible = true;
            trianglepause.visible = false;
          }
        };

     

        box_Container.on("click", function () {
          linestop(tween1);
          linestop(tween2);
          linestop(tween3);
          linestop(tween4);
          linestop(tween5);
          linestop(tween6);
          linestop(tween7);
          linestop(tween8);
          linestop(tween9);
          linestop(tween10);
          linestop(tween11);
          linestop(tween12);
          linestop(tween13);
          linestop(tween14);
          linestop(tween15);
          linestop(tween16);
          linestop(tween29);

          box_Container1.alpha = 1;

        });
        box_Container1.on('click', function () {
          N();
          box_Container1.alpha = 0;
          stage.removeChild(box_Container_disable, box_Container, box_Container1);
          stage.removeChild(r2, text, line, line1, line2, line3, line4, line5, line6, line7, triangle1, triangle2, topline, r1, shape, rectangle1, r3, shape1, line_black, line_black1, line_black2, bitmaps);
        });

        stage.addChild(bitmap);
      }

      function n() {

        var pencil1 = new Image();
        pencil1.src = strbloburl + "/Lasresan/FK/FK-RB/Exercise/Swedishcharacter/Images/pencil.png";
        var bitmaps1 = new createjs.Bitmap(pencil1);
        bitmaps1.setTransform(864, 182, 0.8, 0.8);

        var shape2 = new createjs.Shape();
        shape2.graphics.beginFill("#000000").drawCircle(-45, 55, 6);
        shape2.setTransform(912, 269);

        var shape3 = new createjs.Shape();
        shape3.graphics.beginFill("#FFCF21").drawCircle(867, 324, 15);
        var circleShadow = new createjs.Shadow("#ff0000", 0, 0, 5);
        shape3.shadow = circleShadow;
        circleShadow.blur = 0;
        createjs.Tween.get(circleShadow).to({
          blur: 50
        }, 500).wait(100).to({
          blur: 0
        }, 500).to({
          blur: 50
        }, 500).wait(10).to({
          blur: 5
        }, 500);
        var data = {          
          frames: {
            width: 40,
            height: 40
          },
          animations: {
            trash: 0,
            male: 1,
            wait: 2,
            library: 3,
            female: 4,
            hanger: 5,
            stairs: 6,
            noparking: 7
          }
        }

        var r4 = new createjs.Shape();
        r4.graphics.f('#FFFFFF').s('lightgrey').ss(2).drawRect(0, 0, 380, 190)
        r4.setTransform(734, 134);

        var r5 = new createjs.Shape();
        r5.graphics.f('#D6EDF1').s('lightgrey').ss(2).drawRect(0, 0, 380, 197)
        r5.setTransform(734, 324);

        var r6 = new createjs.Shape();
        r6.graphics.f('#ffffff').s('lightgrey').ss(2).drawRect(0, 0, 380, 183)
        r6.setTransform(734, 521);

        var rectangle2 = new createjs.Shape();
        rectangle2.graphics.f('').s('#B7E1E6').ss(2).drawRoundRect(0, 0, 407, 602, 10)
        rectangle2.setTransform(721, 118.6);

        var text1 = new createjs.Text("n", "750px MajemaSkol", "#000000");        
        text1.textBaseline = "alphabetic";
        text1.x = 819;
        text1.y = 520;

        var box_Container_b = new createjs.Container();
        var playrect = new createjs.Shape();
        playrect.graphics.f('#2398D1').s('#2398D1').ss(1.5).drawRect(0, 0, 40, 40);
        playrect.setTransform(597, 480);

        var triangleplay = new createjs.Shape();
        triangleplay.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(1.5).moveTo(0, 0).lineTo(0, 16).lineTo(10, 8).lineTo(0, 0);
        triangleplay.setTransform(614, 492);

        var trianglepause = new createjs.Shape();
        trianglepause.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(5).moveTo(0, 0).lineTo(0, 16).moveTo(10, 0).lineTo(10, 16);
        trianglepause.setTransform(613, 492);
        trianglepause.visible = false;

        box_Container_b.addChild(playrect, triangleplay, trianglepause);
        box_Container_b.setTransform(334, 274);
        box_Container_b.alpha = 1;
        box_Container_b.visible = true;

        var box_Container_disable_b = new createjs.Container();

        var playrect_disable = new createjs.Shape();
        playrect_disable.graphics.f('#2398D1').s('#2398D1').ss(1.5).drawRect(0, 0, 40, 40);
        playrect_disable.setTransform(597, 480);

        var triangleplay_disable = new createjs.Shape();
        triangleplay_disable.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(1.5).moveTo(0, 0).lineTo(0, 16).lineTo(10, 8).lineTo(0, 0);
        triangleplay_disable.setTransform(614, 492);

        box_Container_disable_b.addChild(playrect_disable, triangleplay_disable);
        box_Container_disable_b.setTransform(334, 274);
        box_Container_disable_b.alpha = 0.4;
        box_Container_disable_b.visible = false;

        //play from starting (restart)   

        var box_Container1_b = new createjs.Container();

        var previous = new createjs.Shape();
        previous.graphics.f('#2398D1').s('#2398D1').ss(1.5).drawRect(0, 0, 40, 40);
        previous.setTransform(550, 480);

        var triangleprev = new createjs.Shape();
        triangleprev.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(1.5).moveTo(0, 0).lineTo(0, 16).lineTo(10, 8).lineTo(0, 0);
        triangleprev.setTransform(577, 509);
        triangleprev.rotation = 180;

        var triangleprevpause = new createjs.Shape();
        triangleprevpause.graphics.f("#FFFFFF").beginStroke("#FFFFFF").setStrokeStyle(5).moveTo(0, 0).lineTo(0, 16);
        triangleprevpause.setTransform(565, 493);

        box_Container1_b.addChild(previous, triangleprev, triangleprevpause);
        box_Container1_b.setTransform(334, 274);
        box_Container1_b.alpha = 0.4;


        var line10 = new createjs.Shape();
        line10.graphics.beginStroke("#D6EDF1").setStrokeStyle(22).moveTo(10, 195);
        line10.setTransform(854, 325);
        var cmd10 = line10.graphics.lineTo(10, 0).command;

        var B2: any = new createjs.Shape().set({ x: 939, y: 392 });
        B2.graphics.ss(24).s("#D6EDF1");
        var cmd_B2 = B2.graphics.arc(0, 0, 60, 3.60, 2 * Math.PI).command;       

        var line11 = new createjs.Shape();
        line11.graphics.beginStroke("#D6EDF1").setStrokeStyle(22).moveTo(10, 128);
        line11.setTransform(989, 392);
        var cmd11 = line11.graphics.lineTo(10, 0).command;

        var hiddenshape = new createjs.Shape();
        hiddenshape.graphics.beginStroke("#D6EDF1").setStrokeStyle(1).f("#D6EDF1").moveTo(0, -2).lineTo(0, 55).lineTo(18, 8).lineTo(0, -2);
        hiddenshape.setTransform(875.5, 360);

        var B6: any = new createjs.Shape().set({ x: 954, y: 415 });
        B6.graphics.ss(17).s("#000000");
        var cmd_B6 = B6.graphics.arc(0, 0, 88, 0.84 * Math.PI, 0.84 * Math.PI).command;
        B6.rotation = 35;

        var tween_a = createjs.Tween.get(cmd10, { paused: true }).wait(1000).to({ x: 10, y: 200 }, 1000);
        var tween_d = createjs.Tween.get(cmd_B6, { paused: true }).wait(2500).to({ endAngle: 1.02 * Math.PI }, 300);
        var tween_c = createjs.Tween.get(cmd_B2, { paused: true }).wait(2800).to({ startAngle: 2 * Math.PI }, 800);
        var tween_b = createjs.Tween.get(cmd11, { paused: true }).wait(3600).to({ x: 10, y: 130 }, 600);


        // pencil
        var tween_e = createjs.Tween.get(bitmaps1, { paused: true }).wait(1000).to({ x: 864, y: 375 }, 1000)
          .to({ x: 864, y: 263 }, 500)
          .to({ x: 882, y: 218 }, 300)
          .to({
            guide: {
              path: [882, 218, 884, 220, 894, 207, 904, 200, 914, 195, 924, 195,
                944, 193, 954, 195, 964, 197, 974, 202, 982, 212,
                991, 226, 997, 245
              ]
            }
          }, 800)

          .to({ x: 997, y: 375 }, 600)
          .wait(1000).to({ alpha: 0 }, 0);

        // animation circles
        var tween_f = createjs.Tween.get(shape3, { paused: true }).wait(500).to({ alpha: 0 }, 0);
        var tween_g = createjs.Tween.get(shape2, { paused: true }).wait(500).to({ alpha: 0 }, 0);


        var tween_z = createjs.Tween.get(box_Container_b, { paused: true }).wait(5200).call(function () {
          playdisable1();
          myAudio.play();
        });

        function playdisable1() {
          box_Container_b.visible = false;
          box_Container_disable_b.visible = true;
        }

        var myAudio: any = document.getElementById("myAudio");
        myAudio.oncanplaythrough = setTimeout(function () {
          setTime()
        }, 900);
        function setTime() {
          // myAudio1.currentTime = ;
        } 

        function linestop1(tween) {
          if (tween._paused) {
            tween.paused = false;
            tween.setPaused(false);
            
            trianglepause.visible = true;
            triangleplay.visible = false;
          } else {
            tween.paused = true;
            tween.setPaused(true);
          
            triangleplay.visible = true;
            trianglepause.visible = false;
          }
        };

        box_Container_b.on("click", function () {
          linestop1(tween_a);
          linestop1(tween_b);
          linestop1(tween_c);
          linestop1(tween_d);
          linestop1(tween_e);
          linestop1(tween_f);
          linestop1(tween_g);
          linestop1(tween_z);
          box_Container1_b.alpha = 1;

        });

        box_Container1_b.on('click', function () {
          n();
          box_Container1_b.alpha = 0;
          stage.removeChild(box_Container_b, box_Container_disable_b, box_Container1_b);
          stage.removeChild(r5, text1, hiddenshape, line10, B2, line11, B6, r4, rectangle2, r6, shape3, shape2, bitmaps1);
        });

        stage.addChild(box_Container_b, box_Container_disable_b, box_Container1_b);
        stage.addChild(r5, text1, hiddenshape, line10, B2, line11, B6, r4, rectangle2, r6, shape3, shape2, bitmaps1);
      }

      }
stage.mouseMoveOutside = false;
      stage.enableMouseOver();
      createjs.Ticker.reset();
      createjs.Ticker.framerate = 60;
      createjs.Ticker.addEventListener("tick", this.stage);
      createjs.Ticker.addEventListener("tick", createjs.Tween);
      createjs.Ticker.timingMode = createjs.Ticker.RAF;
    }

    onCloseCancel() {
      var myAudio: any = document.getElementById("myAudio");
      myAudio.src = "";
      createjs.Ticker.reset();
      createjs.Touch.disable(this.stage);
      createjs.Tween.removeAllTweens();
      this.stage.enableMouseOver(0);
      this.stage.clear();
      this.thisDialogRef.close('Cancel');
      let toggler: any = document.getElementById("toggler");
      if (toggler) {
        toggler.style.visibility = "visible";
      }
    }
  }

